export default __webpack_public_path__ + "static/media/5D0A0A35-CCD6-469E-8A1C-1EF5FEE7621F.eb64a94f.jpg";